import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { DataGrid } from '@mui/x-data-grid';
import LinearProgress from '@mui/material/LinearProgress';
//import SvgIcon from '@mui/material/SvgIcon';
//import "./Table.css";

/*
function YIcon(props) {
  return (
    <SvgIcon {...props}>
      <text x="0" y="15" fill="red">Y</text>
    </SvgIcon>
  );
}

function NIcon(props) {
  return (
    <SvgIcon {...props}>
      <text>N</text>
    </SvgIcon>
  );
}
*/

function isOverflown(element) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

const GridCellExpand = React.memo(function GridCellExpand(props) {
  const { width, value } = props;
  const wrapper = React.useRef(null);
  const cellDiv = React.useRef(null);
  const cellValue = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showFullCell, setShowFullCell] = React.useState(false);
  const [showPopper, setShowPopper] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);

  const handleMouseEnter = () => {
    const isCurrentlyOverflown = isOverflown(cellValue.current);
    setShowPopper(isCurrentlyOverflown);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  };

  const handleMouseLeave = () => {
    setShowFullCell(false);
  };

  React.useEffect((isLoading) => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);

  React.useEffect(() => {
    if (!showFullCell) {
      return undefined;
    }

    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        setShowFullCell(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setShowFullCell, showFullCell]);

  return (
    <Box
      ref={wrapper}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        alignItems: 'center',
        lineHeight: '24px',
        width: '100%',
        height: '50%',
        position: 'relative',
        display: 'flex',
      }}
    >
      <Box
        ref={cellDiv}
        sx={{
          height: '100%',
          width,
          display: 'block',
          position: 'absolute',
          top: 0,
        }}
      />
      <Box
        ref={cellValue}
        sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {value}
      </Box>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
          placement='bottom'
          style={{ width, marginLeft: -17 }}
        >
          <Paper
            elevation={1}
            style={{ minHeight: wrapper.current.offsetHeight - 3 }}
          >
            <Typography variant="body2" style={{ padding: 8, wordBreak: 'break-word' }}>
              {value}
            </Typography>
          </Paper>
        </Popper>
      )}
    </Box>
  );
});

GridCellExpand.propTypes = {
  value: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
};

export function renderCellExpand(params) {
  return (
    <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth} />
  );
}

renderCellExpand.propTypes = {
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The cell value, but if the column has valueGetter, use getValue.
   */
  value: PropTypes.string,
};


const Table = ({ data, columns, hiddenColumns, viewRowData, viewCellData, isLoading }) => {

  const defaultPageSize = 20;

  return (

    <div style={{ display: 'flex', height: '100%' }}>
      <div style={{ flexGrow: 1, width: "1237px" }}>
        <DataGrid
          components={{
            LoadingOverlay: LinearProgress,
          }}
          loading={isLoading}
          rows={data}
          columns={columns}
          disableColumnFilter
          autoHeight
          pagination
          hideFooterSelectedRowCount
          rowsPerPageOptions={[]}
          getRowHeight={() => 'auto'}
          onRowDoubleClick={(params, event) => viewRowData(params, event)}
          onCellClick={(params, event) => viewCellData !== undefined && viewCellData(params, event)}
          initialState={{
            columns: {
              columnVisibilityModel: {
                ...hiddenColumns
              },
            },
            pagination: {
              paginationModel: {
                pageSize: defaultPageSize,
              },
            }
          }}
        sx={{
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: '#F7F7F8',
            color: "#666663",
            "min-height": '36px!important',
            "line-height": '36px!important',
            "height": '36px!important'
          }
        }}
        />

      </div>
    </div>


  );

}


export default Table;